<!--
* @Name：定价方式审批基本页面
* @Author: 王超
* @Date: 2025-09-17 10:39:49
* @Last Modified by: 王超
* @Last Modified time: 2025-09-17 10:39:49
-->
<template>
  <div>
    <hi-cell title="采购类别：" :value="headInfo.catgName"></hi-cell>
    <hi-cell title="采购部门：" :value="headInfo.purorgName"></hi-cell>
    <hi-cell title="询比价类型：" :value="headInfo.pcType" :options="pcTypeOptions"></hi-cell>
    <hi-cell title="项目名称：" :value="headInfo.projectName"></hi-cell>
    <hi-cell title="项目编号：" :value="headInfo.pcInfoId"></hi-cell>
    <hi-cell title="项目负责人：" :value="headInfo.crtUserName"></hi-cell>
    <hi-cell title="报价币种：" :value="headInfo.currencyName"></hi-cell>
  </div>
</template>

<script>
export default {
  name: 'BaseInfo',
  components: {},
  data() {
    return {}
  },
  props: {
    headInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // 询价比类型参照
    pcTypeOptions() {
      return this.$store.getters.dicts.price_comp_type
    },
    currencyOptions() {
      return this.$store.getters.dicts.currency
    }
  }
}
</script>
